<div *ngIf="!isCartera"  [ngClass]="classes" >
    <span class="name">{{accountName | shortName  | uppercase}}</span>
</div>
<div *ngIf="isCartera" class="cartera" ></div>